import { debug } from 'loglevel'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// const myStorage = window.localStorage
// let locale = myStorage.getItem('locale')
// if(!['en', 'zh-TW', 'zh-CN'].includes(locale)) {
//   locale = 'zh-TW'
// }
// debug('locale', locale)

const i18n = new VueI18n({
  // locale: process.env.VUE_APP_I18N_LOCALE || 'zh-TW',
  locale: 'zh-TW',
  // locale: 'en',
  // locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh-TW',
  messages: loadLocaleMessages()
})

axios.get('/locales/i18n.json').then((resp)=>{
  debug('i18n from axios', typeof resp.data, resp.data)
  const locales = ['en', 'zh-TW', 'zh-CN']
  locales.forEach((locale) => {
    if(resp.data[locale]) {
      i18n.setLocaleMessage(locale, resp.data[locale])
    }
  })
}).catch((err)=>{
  debug('*** err i18n from axios ***', err)
})

export default i18n;
